import styled from "styled-components";
import {fontFamilies} from "theme/tokens";

/** Styles for {@link ../legal/CookieSettingsDialog} — externalized with the ui#2331 rework. */

export const Category = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 16px;
	padding: 14px 0;
	border-bottom: 1px solid ${({theme}) => theme.tokens.line};

	&:last-child {
		border-bottom: none;
	}
`;

export const CategoryText = styled.div`
	font-family: ${fontFamilies.sans};
`;

export const CategoryTitle = styled.div`
	font-weight: 700;
	font-size: 14.5px;
	color: ${({theme}) => theme.tokens.ink};
`;

export const CategoryDesc = styled.p`
	margin: 4px 0 0;
	font-size: 13px;
	line-height: 1.5;
	color: ${({theme}) => theme.tokens.ink2};
`;

export const AlwaysOn = styled.span`
	flex: none;
	align-self: center;
	font-family: ${fontFamilies.mono};
	font-size: 11px;
	font-weight: 700;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	/* signalInk, not the vivid teal accent: the 11px "Always on" label fails WCAG AA on the light
	   card as teal (2.84:1); signalInk is the design's accessible signal foreground (ui#302). */
	color: ${({theme}) => theme.tokens.signalInk};
`;
